const defaultTitle = "红塔仁恒车辆预约系统";
const defaultMeta = {
  // 当前路由对应title
  title: defaultTitle,
  // 是否缓存页面
  keepAlive: false,
  // 是否显示底部Copyright
  showFoot: false,
  // 是否显示左菜单
  showLeftAside: false,
  // 权限显示
  powerList: [],
  // 对应菜单名字
  menuName: ""
};
console.log(defaultMeta);
// 解决权限问题
// 解决激活刷新问题
// 解决菜单分组问题 ok
// 每个页面都都左边菜单配置，方便统计管理，以及整体布局的调整以及优化 ok
const routes = [
  {
    path: "/rhqy",
    redirect: "/rhqy/login"
  },
  {
    path: "/rhqy/login",
    name: "rhqyLogin",
    component: () => import("../Login.vue")
  },
  {
    path: "/rhqy/loginAccout",
    name: "rhqyloginAccout",
    component: () => import("../LoginAccout.vue")
  },
  {
    path: "/rhqy/exportAppointmentData",
    name: "rhqyExportAppointmentData",
    component: () => import("../ExportAppointmentData.vue")
  },
  {
    path: "/rhqy/lyout",
    name: "rhqyLyout",
    component: () => import("../Lyout.vue"),
    meta: {
      // keepAlive: true
    },
    children: [
      // 没有左菜单部分
      {
        path: "/rhqy/lyoutNn",
        name: "rhqyLyoutNn",
        component: () => import("../LyoutNn.vue"),
        meta: {
          // keepAlive: true
        },
        children: [
          {
            path: "/rhqy/home",
            redirect: "/rhqy/home/view"
          },
          {
            path: "/rhqy/home/view",
            name: "rhqyHomeView",
            component: () => import("../ReportMain.vue"),
            meta: {
              // 是否显示底部Copyright
              showFoot: true
            }
          },
          {
            path: "/rhqy/member",
            redirect: "/rhqy/member/view"
          },
          {
            path: "/rhqy/member/view",
            name: "rhqyMemberView",
            component: () => import("../MemberNew.vue"),
            meta: {}
          },
          {
            path: "/rhqy/privilege",
            redirect: "/rhqy/privilege/view"
          },
          {
            path: "/rhqy/privilege/view",
            name: "rhqyPrivilegeView",
            component: () => import("../Privilege/index.vue"),
            meta: {}
          },
          {
            path: "/rhqy/privilege/view/edit/:id?",
            name: "rhqyPrivilegeViewEdit",
            component: () => import("../Privilege/groupEdit.vue"),
            meta: {}
          },
          {
            path: "/rhqy/accout/view",
            name: "rhqyAccoutView",
            component: () => import("../Accout.vue"),
            meta: {}
          },
          {
            path: "/rhqy/accout/logout",
            name: "rhqyAccoutLogout",
            component: () => import("../Logout.vue"),
            meta: {}
          }
        ]
      },
      // 业务管理
      {
        path: "/rhqy/service",
        name: "rhqyLyoutYw",
        component: () => import("../LyoutYw.vue"),
        meta: {
          showLeftAside: true
          // keepAlive: true
        },
        children: [
          {
            path: "/rhqy/service/home",
            name: "rhqyServiceHome",
            component: () => import("../ReportMain.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/report",
            name: "rhqyServiceReportForm",
            component: () => import("../ReportForm/ReportFormList.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/truck/GateManage", // 门口管理
            name: "rhqyServiceTruckGateManage",
            component: () => import("../SafetyRelease/GateManage.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/truck/ReleaseList", // 放行列表
            name: "rhqyServiceTruckReleaseList",
            component: () => import("../SafetyRelease/TruckReleaseList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/truck/ReleaseList/detail/:id?", // 放行车辆详情
            name: "rhqyServiceTruckReleaseDetail",
            component: () => import("../SafetyRelease/TruckReleaseDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/truck/ReleaseLog", // 放行日志
            name: "rhqyServiceTruckReleaseLog",
            component: () => import("../SafetyRelease/ReleaseLog.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/queue/DeliveryList", // 成品出厂
            name: "rhqyServiceQueueDeliveryList",
            component: () => import("../QueueManage/DeliveryList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/queue/DeliveryList/detail/:id?", // 查看车辆详情
            name: "rhqyServiceQueueDeliveryDetail",
            component: () => import("../QueueManage/DeliveryDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/queue/Log", // 排队操作日志
            name: "rhqyServiceQueueLog",
            component: () => import("../QueueManage/QueueLog.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/serviceList", // 预约业务管理
            name: "rhqyServiceAppointServiceList",
            component: () => import("../AppointManage/ServiceList.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/groupList", // 预约业务组管理
            name: "rhqyServiceAppointGroupList",
            component: () => import("../AppointManage/GroupList.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeTplList", // 预约时间模板
            name: "rhqyServiceAppointTimeTplList",
            component: () => import("../AppointManage/TimeTplList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeTplList/addAndEdit/:id?", // 新建/编辑预约时间模板
            name: "rhqyServiceAppointTimeTplModify",
            component: () => import("../AppointManage/TimeTplModify.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeTplList/detail/:id?", // 查看模板详情
            name: "rhqyServiceAppointTimeTplDetail",
            component: () => import("../AppointManage/TimeTplDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeCaseList", // 预约时间实例
            name: "rhqyServiceAppointTimeCaseList",
            component: () => import("../AppointManage/TimeCaseList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeCaseList/detail/:id?", // 查看实例详情
            name: "rhqyServiceAppointTimeCaseDetail",
            component: () => import("../AppointManage/TimeCaseDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/timeCaseList/modify/:id?", // 修改实例号源
            name: "rhqyServiceAppointTimeCaseModify",
            component: () => import("../AppointManage/TimeCaseModify.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/accordList", // 预约记录管理
            name: "rhqyServiceAppointAccordList",
            component: () => import("../AppointManage/AccordList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/appoint/detail", // 查看预约详情
            name: "rhqyServiceAppointDetail",
            component: () => import("../AppointManage/AppointDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/accordList/truckDetail/:id?", // 放行车辆详情（预约）
            name: "rhqyServiceAccordTruckDetail",
            component: () => import("../SafetyRelease/TruckReleaseDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/appoint/log", // 预约操作日志
            name: "rhqyServiceAppointLog",
            component: () => import("../AppointManage/AppointLog.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/coopera/CategoryManage", // 类别管理
            name: "rhqyServiceCooperaCategoryManage",
            component: () => import("../CooperaManage/CategoryManage.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/coopera/List", // 单位管理列表
            name: "rhqyServiceCooperaList",
            component: () => import("../CooperaManage/CooperaList.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/coopera/List/modify/:id?", // 编辑单位详情
            name: "rhqyServiceCooperaModify",
            component: () => import("../CooperaManage/CooperaModify.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/coopera/List/detail/:id?", // 单位详情
            name: "rhqyServiceCooperaDetail",
            component: () => import("../CooperaManage/CooperaDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/coopera/Log", // 操作日志
            name: "rhqyServiceCooperaLog",
            component: () => import("../CooperaManage/CooperaLog.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/approval", // 审批列表
            name: "rhqyServiceApproval",
            component: () => import("../Approval/ApprovalList.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/approval/category", // 审批列表-类别管理
            name: "rhqyServiceApprovalCategory",
            component: () => import("../Approval/ApprovalCategory.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/approval/info", // 审批列表-消息管理
            name: "rhqyServiceApprovalInfo",
            component: () => import("../Approval/ApprovalInfo.vue"),
            meta: {
              showLeftAside: true,
              keepAlive: true
            }
          },
          {
            path: "/rhqy/service/approval/info/modify/:id?", // 审批列表-消息管理编辑
            name: "rhqyServiceApprovalInfoModify",
            component: () => import("../Approval/ApprovalInfoModify.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/approval/info/detail/:id?", // 审批列表-消息管理详情
            name: "rhqyServiceApprovalInfoDetail",
            component: () => import("../Approval/ApprovalInfoDetail.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/store/List", // 仓库及库位管理
            name: "rhqyServiceStoreList",
            component: () => import("../StoreManage/StoreList.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/store/Log", // 操作日志
            name: "rhqyServiceStoreLog",
            component: () => import("../StoreManage/StoreLog.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/safe/notice", // 安全告知书
            name: "rhqyServiceSafeNotice",
            component: () => import("../Notice/SafeNotice.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/store/switch", // 盖篷布开关管理
            name: "rhqyServiceStoreSwitch",
            component: () => import("../StoreManage/StoreSwitch.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/service/store/qrcode", // 一码通管理
            name: "rhqyServiceStoreQrcode",
            component: () => import("../StoreManage/StoreQrcode.vue"),
            meta: {
              showLeftAside: true
            }
          }
        ]
      },
      //应用设置
      {
        path: "/rhqy/yyManege",
        name: "rhqyLyoutYy",
        component: () => import("../LyoutYy.vue"),
        meta: {
          showLeftAside: true
        },
        children: [
          {
            path: "/rhqy/yyManege/carAppoint/:id?",
            name: "rhqyYyManegeCarAppoint",
            component: () => import("../AppManege/CarAppoint.vue"),
            meta: {
              showLeftAside: true
            }
          }
        ]
      },
      // 组织架构
      {
        path: "/rhqy/org",
        name: "rhqyLyoutOrg",
        component: () => import("../LyoutOrg.vue"),
        meta: {
          showLeftAside: true
        },
        children: [
          {
            path: "/rhqy/org/member",
            name: "rhqyOrgMember",
            component: () => import("../MemberNew.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/org/label",
            name: "rhqyOrgLabel",
            component: () => import("../Label.vue"),
            meta: {
              showLeftAside: true
            }
          }
        ]
      },
      // 权限管理
      {
        path: "/rhqy/pri",
        name: "rhqyLyoutPri",
        component: () => import("../LyoutPri.vue"),
        meta: {
          showLeftAside: true
        },
        children: [
          {
            path: "/rhqy/pri/app/index",
            name: "rhqyPriApp",
            component: () => import("../Privilege/index.vue"),
            meta: {
              showLeftAside: true
            }
          },
          {
            path: "/rhqy/pri/app/index/edit/:id?",
            name: "rhqyPriAppEdit",
            component: () => import("../Privilege/groupEdit.vue"),
            meta: { showLeftAside: true }
          },
          {
            path: "/rhqy/pri/admin",
            name: "rhqyOrgLabelAdmin",
            component: () => import("../Privilege/admin.vue"),
            meta: {
              showLeftAside: true
            }
          }
        ]
      }
    ]
  }
];
export default routes;
